// extracted by mini-css-extract-plugin
export default {"header":"header-fXiLJ","body":"body-Mz0Pk","hint":"hint-DlZ9Q","spacer":"spacer-lBjIb","info":"info-ldAHq","title":"title-S0W86"};